// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
import styled from 'styled-components';
import { Form, FormGroup, FormControl } from 'react-bootstrap';

const StyleForm = styled(Form)`
  margin-bottom: 20px;
`;

const StyleEmailControl = styled(FormControl)`
  width: 250px;
`;

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/prop-types
const PartyAddMemberSearch = ({ emailValue, setEmailValue }) => (
  <StyleForm>
    <FormGroup>
      <StyleEmailControl
        type='text'
        placeholder='Email (3 characters min)'
        onChange={e => setEmailValue(e.target.value)}
        value={emailValue}
      />
    </FormGroup>
  </StyleForm>
);

export default React.memo(PartyAddMemberSearch);
